import {Route, RouterModule}    from '@angular/router';
import {PageMode}               from '../ap-interface';
import {NgModule}               from '@angular/core';
import {InfoLegalComponent}     from './components/info-legal.component';
import {InfoAgreementComponent} from './components/info-agreement.component';
import {InfoImprintComponent}   from './components/info-imprint.component';
import {InfoContactComponent}   from './components/info-contact.component';

const routes: Route[] = [
  {
    path: 'contact',
    component: InfoContactComponent,
    data: {
      login: true,
      layout: PageMode.HALFSCREEN
    }
  },
  {
    path: 'legal',
    component: InfoLegalComponent,
    data: {
      login: false,
      layout: PageMode.FULLSCREEN
    }
  },
  {
    path: 'agreement',
    component: InfoAgreementComponent,
    data: {
      login: true,
      layout: PageMode.HALFSCREEN
    }
  },
  {
    path: 'imprint',
    component: InfoImprintComponent,
    data: {
      login: true,
      layout: PageMode.HALFSCREEN
    }
  }
];

@NgModule({
  imports: [
    RouterModule.forChild(routes)
  ],
  exports: [RouterModule]
})
export class ApInfoRoutes {
}
